import React from 'react';

const TableChart = ({ data, options = {}, fieldConfig = {} }) => {
  // Ensure data is an array (gauge/stat pass number/object)
  const rows = Array.isArray(data) ? data : [];

  if (!rows.length) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <span style={{ color: '#8c8c8c' }}>No data</span>
      </div>
    );
  }

  // Get all unique column keys from data
  const columns = Array.from(
    new Set(rows.flatMap(row => Object.keys(row || {})))
  ).filter(key => !key.startsWith('_')); // Filter internal keys

  return (
    <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
      <table style={{ width: '100%', fontSize: '12px', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#fafafa', borderBottom: '2px solid #f0f0f0', position: 'sticky', top: 0 }}>
            {columns.map(col => (
              <th 
                key={col}
                style={{ 
                  padding: '12px', 
                  textAlign: 'left', 
                  fontWeight: 600, 
                  color: '#262626',
                  textTransform: 'capitalize'
                }}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex} style={{ borderBottom: '1px solid #f0f0f0' }}>
              {columns.map(col => (
                <td 
                  key={col}
                  style={{ 
                    padding: '12px', 
                    color: '#595959',
                    fontWeight: col === 'value' ? 600 : 400
                  }}
                >
                  {typeof row[col] === 'number' 
                    ? row[col].toLocaleString() 
                    : (row[col] || '-')
                  }
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableChart;